<template>
  <v-container>
    <h2>Request Helper Status</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        Status: {{ status_name }}
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'request-helper-status-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "RequestHelperStatusView",
  data: () => ({
    status_id: 0,
    status_name: null
  }),
  async mounted () {
    this.status_id = this.$route.params.id
    await this.getRequestHelperStatus()
  },
  methods: {
    async getRequestHelperStatus () {
      try {
        const { data } = await this.$http.get(`/back-office/request-helper-status/${this.status_id}`, authHeader())
        this.status_name = data.status_name
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    }
  },
};
</script>
